import { HeaderLogo } from '@/components/HeaderLogo'
import AccountIcon from '@/components/Icon/AccountIcon'
import CartIcon from '@/components/Icon/CartIcon'
import HeaderShareIcon from '@/components/Icon/HeaderShareIcon'
import { MegaMenu } from '@/components/MegaMenu/MegaMenu'
import { SearchBar } from '@/components/SearchBar'
import { useAuth, useStore } from '@/containers'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface HeaderLogo {
  label: JSX.Element | null
  key: number
}

type HeaderProps = {
  page?: string
}

const Header = ({ page }: HeaderProps) => {
  const t = useTranslations('Header')
  const { user, logout, cart, setIsOpenListAddress } = useAuth()
  const lastName = user?.name.split(' ').slice(-1).join(' ')
  const router = useRouter()
  const { setIsOpenShare } = useStore()

  return (
    <header className='z-[50] bg-primary pb-3 pt-7'>
      <div className='container relative mx-auto flex items-center'>
        <div className='h-12'>
          {page && page == 'homepage' ? (
            <HeaderLogo type={1} />
          ) : (
            <HeaderLogo type={1} />
          )}
        </div>
        <MegaMenu />
        <div className='ml-5 min-w-0 grow'>
          <SearchBar />
        </div>
        {user ? (
          <div className='ml-6 inline-flex h-12'>
            <DropdownMenu.Root>
              <DropdownMenu.Trigger asChild>
                <div className='relative flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-full bg-[#FFFFFF1A] px-4 text-sm text-white'>
                  <AccountIcon />
                  <span className='font-semibold hover:cursor-pointer'>
                    {t('sayHi')}, {lastName}{' '}
                  </span>
                </div>
              </DropdownMenu.Trigger>

              <DropdownMenu.Portal>
                <DropdownMenu.Content
                  className='DropdownLanguageContent z-[99999] overflow-hidden'
                  sideOffset={15}
                  side='bottom'
                  align='end'
                  sticky='always'
                >
                  <DropdownMenu.Item
                    onClick={() => router.push('/account?tab=account')}
                    className='DropdownAccountItem flex h-[40px] cursor-pointer items-center border-t-[1px] border-grey-1200 text-sm font-normal text-dark-400 outline-none first:border-t-[0px] hover:bg-sky-100 hover:text-blue-600'
                  >
                    <span className='px-3'>Thông tin tài khoản</span>
                  </DropdownMenu.Item>
                  <DropdownMenu.Item
                    onClick={() => setIsOpenListAddress(true)}
                    className='DropdownAccountItem flex h-[40px] cursor-pointer items-center border-t-[1px] border-grey-1200 text-sm font-normal text-dark-400 outline-none first:border-t-[0px] hover:bg-sky-100 hover:text-blue-600'
                  >
                    <span className='px-3'>Địa chỉ giao hàng</span>
                  </DropdownMenu.Item>
                  <DropdownMenu.Item
                    onClick={() => logout()}
                    className='DropdownAccountItem flex h-[40px] cursor-pointer items-center border-t-[1px] border-grey-1200 text-sm font-normal text-dark-400 outline-none first:border-t-[0px] hover:bg-sky-100 hover:text-blue-600'
                  >
                    <span className='px-3'>Đăng xuất</span>
                  </DropdownMenu.Item>
                </DropdownMenu.Content>
              </DropdownMenu.Portal>
            </DropdownMenu.Root>
          </div>
        ) : (
          <Link
            href='/login'
            className='ml-5 flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-[#FFFFFF1A] px-4 text-sm font-semibold text-white'
          >
            <AccountIcon />
            <span>{t('login')}</span>
          </Link>
        )}
        <Link
          href='/checkout/cart'
          className='relative ml-3 flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-[#FFFFFF1A] px-4 text-sm font-semibold text-white'
        >
          <CartIcon />
          <span className='absolute left-8 top-2 flex h-4 w-4 items-center justify-center rounded-full bg-secondary text-sm font-medium'>
            {cart?.quantity && cart.quantity > 9 ? '9+' : cart.quantity}
          </span>

          <span className='whitespace-nowrap font-semibold'>{t('cart')}</span>
        </Link>
        <button
          onClick={() => setIsOpenShare(true)}
          className='ml-3 flex h-12 items-center gap-2 whitespace-nowrap rounded-full border-none bg-[#FFFFFF1A] fill-white px-4 text-sm font-semibold text-white outline-none'
        >
          <HeaderShareIcon />
          <span>Chia sẻ</span>
        </button>
      </div>
    </header>
  )
}
export { Header }
